import { UI, HStack } from '@genial/components';
import { Color } from '@genial/design-tokens';

import { useGlobalProductContext } from '../../contexts';

export const ProductCaptions = () => {
  const { product } = useGlobalProductContext();

  const { captions } = product;

  if (!captions.length) {
    return <></>;
  }

  return (
    <HStack alignItems="center" space="inline.xxs" pt="stack.xxs">
      {captions.map(({ icon, iconColor, text, iconSize }) => (
        <UI.Caption
          key={`caption-${icon}`}
          testId={`caption-${icon}`}
          icon={icon}
          iconColor={Color[iconColor]}
          text={text}
          iconSize={iconSize || 'xs'}
        />
      ))}
    </HStack>
  );
};
